import { Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FormControlBase } from '../../../../modules/tcm-form/common/form-control-base/form-control-base';

@Component({
    selector: 'tcm-color-picker-input',
    templateUrl: './tcm-color-picker-input.html',
    styleUrls: ['./tcm-color-picker-input.scss'],
    inputs: ['label', 'disabled', 'hideValidationMessages', 'isReadonlyValue', 'placeholder', 'tabindex'],
    standalone: false
})
export class TcmColorPickerInputComponent extends FormControlBase<string>  {
    constructor(@Self() @Optional() protected override ngModel: NgControl) {
        super('tcm-color-picker-input', ngModel);
    }
}
